var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { MasterService } from '@app/utility/master.service';
import { Router } from "@angular/router";
import { timer } from 'rxjs/observable/timer';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
var RefundDepositsComponent = /** @class */ (function () {
    function RefundDepositsComponent(Api, Util, MasterService, router, translate) {
        this.Api = Api;
        this.Util = Util;
        this.MasterService = MasterService;
        this.router = router;
        this.translate = translate;
        this.Editable = false;
        this.FileList = [];
        this.DocumentList = [];
        this.TotalFileSize = 0;
        this.InvestigateFlag = false;
        this.AppealFlag = false;
        this.OTPRefCode = "";
        this.ElapseTime = 0;
        this.TotalTime = 0;
        this.menuEnabled = false;
        this.otpSkip = false;
        this.drosWeb = "";
        this.PathPdf = "";
    }
    RefundDepositsComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var config, crisisConfig, otpConfig, isCrisis, menuList, thisMenu, thisTs_1, userDetail, dob, para, tmp, _a, _b, _c, _d, para_1, _e, LastDate_1, TmpTicket_1, State, objSession, v, v, TableDocs, _f, e_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 30, , 31]);
                        this.Util.ShowWaiting(true);
                        return [4 /*yield*/, this.Api.get("master", "configuration")];
                    case 1:
                        config = _g.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        otpConfig = config.filter(function (c) {
                            return c.dpa_name == "OTP";
                        });
                        isCrisis = void 0;
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            isCrisis = true;
                        }
                        else {
                            isCrisis = false;
                        }
                        if (otpConfig != null && otpConfig.length > 0 && otpConfig[0].dpa_crisisflag != null && otpConfig[0].dpa_crisisflag == true) {
                            this.OtpFlag = true;
                        }
                        else {
                            this.OtpFlag = false;
                        }
                        return [4 /*yield*/, this.Api.get("master", "customerPortalMenuSetting")];
                    case 2:
                        menuList = _g.sent();
                        thisMenu = this.Util.getMenuObj(menuList, "06", isCrisis);
                        if (!thisMenu.show) {
                            this.Util.ShowWaiting(false);
                            setTimeout(function () {
                                _this.router.navigate(["mainmenu/index"]);
                            }, 500);
                            return [2 /*return*/];
                        }
                        else {
                            this.menuEnabled = true;
                        }
                        this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
                        thisTs_1 = this;
                        if (!(this.PortalUser == null || this.PortalUser.contactid == null || this.PortalUser.contactid == "")) return [3 /*break*/, 3];
                        this.Util.WarningDialog("กรุณาเข้าสู่ระบบ");
                        $("#btnWarningOK").off("click");
                        $("#btnWarningOK").click(function () {
                            thisTs_1.router.navigate(["/mainmenu/login"]);
                        });
                        return [2 /*return*/];
                    case 3: return [4 /*yield*/, this.Api.get("crmservice", "contact", "contactid=" + this.PortalUser.contactid)];
                    case 4:
                        userDetail = _g.sent();
                        $("#FirstNameDOPA").val(userDetail[0].firstname);
                        $("#LastNameDOPA").val(userDetail[0].lastname);
                        $("#IDNoDOPA").val(userDetail[0].dpa_idcard);
                        if (userDetail[0].birthdate != null && userDetail[0].birthdate != "") {
                            dob = new Date(userDetail[0].birthdate.replace("z", ""));
                            dob.setFullYear(dob.getFullYear() + 543);
                            $("#BirthDateDOPA").val(moment(dob).format('DD/MM/YYYY'));
                        }
                        else {
                            $("#BirthDateDOPA").val("");
                        }
                        _g.label = 5;
                    case 5:
                        para = "dpaCode=PRIVACY_POLICY";
                        return [4 /*yield*/, this.Api.get("crmservice", "getPolicy", para)];
                    case 6:
                        tmp = _g.sent();
                        if (!this.Util.IsNullOrUndefined(tmp.policyDetail)) {
                            $("#refPolicy").html(tmp.policyDetail);
                        }
                        // boy add
                        _a = this;
                        return [4 /*yield*/, (this.Api.getCustomAPI("User", "GetUser", "username=" + this.PortalUser.email))];
                    case 7:
                        // boy add
                        _a.Profile = _g.sent();
                        if (!(this.Profile != null)) return [3 /*break*/, 28];
                        this.Profile = this.Profile;
                        _b = this;
                        return [4 /*yield*/, (this.Api.get("crmservice", "contact", "contactid=" + this.Profile.customerid))];
                    case 8:
                        _b.Contact = _g.sent();
                        this.Contact = this.Contact[0];
                        _c = this;
                        return [4 /*yield*/, this.Api.get("master", "approvalStatus")];
                    case 9:
                        _c.masterStatus = _g.sent();
                        _d = this;
                        return [4 /*yield*/, (this.Api.get("crmservice", "searchApprovalTicket", "contactid=" + this.Profile.customerid))];
                    case 10:
                        _d.Ticket = _g.sent();
                        para_1 = "CRM02=true&CRM03=true&CRM04=true&CRM05=true&CRM06=true&CRM07=true";
                        if (this.Contact.dpa_idcard != null) {
                            para_1 += "&dpa_id=" + this.Contact.dpa_idcard;
                        }
                        else if (this.Contact.dpa_passport != null) {
                            para_1 += "&dpa_id=" + this.Contact.dpa_passport;
                        }
                        else if (this.Contact.dpa_registrationid != null) {
                            para_1 += "&dpa_id=" + this.Contact.dpa_registrationid;
                        }
                        _e = this;
                        return [4 /*yield*/, this.Api.get("crmservice", "contactDros", para_1)];
                    case 11:
                        _e.ContactDros = _g.sent();
                        this.Util.ShowWaiting(false);
                        if (this.Ticket.length > 1) {
                            this.Ticket.forEach(function (a) {
                                if (LastDate_1 == null || LastDate_1 == undefined) {
                                    LastDate_1 = new Date(a.dpa_submitdate);
                                    TmpTicket_1 = a;
                                }
                                else {
                                    if (LastDate_1 < new Date(a.dpa_submitdate)) {
                                        LastDate_1 = new Date(a.dpa_submitdate);
                                        TmpTicket_1 = a;
                                    }
                                }
                            });
                            this.Ticket = TmpTicket_1;
                        }
                        else if (this.Ticket.length == 1) {
                            this.Ticket = this.Ticket[0];
                        }
                        else {
                            this.Ticket = {
                                dpa_approvalticketid: null,
                                dpa_name: null,
                                dpa_contactid: this.Contact.contactid,
                                dpa_contactidname: this.Contact.firstname + (this.Contact.lastname == null ? "" : (" " + this.Contact.lastname)),
                                dpa_submitdate: new Date().toISOString().substring(0, 10),
                                dpa_originalsource: 1,
                                dpa_remark: null,
                                dpa_approvalstatuscode: '01',
                                dpa_approvalstatusid: thisTs_1.GetStatusGuidByCode("01"),
                                dpa_documentchecklist: "",
                                attachfilelist: [],
                                dpa_idcard: this.Contact.dpa_idcard,
                                dpa_passport: this.Contact.dpa_passport,
                                dpa_registrationid: this.Contact.dpa_registrationid,
                                dpa_authorizedperson: this.Contact.dpa_authorizedperson,
                                dpa_authorizedperson_idcard: this.Contact.dpa_authorizedperson_idcard,
                                dpa_personaltypeid: this.Contact.dpa_personaltypeid,
                                dpa_personaltypeidname: this.Contact.dpa_personaltypeidname,
                                dpa_companytypeid: this.Contact.dpa_companytypeid,
                                dpa_companytypeidname: this.Contact.dpa_companytypeidname,
                                dpa_attachsizing: 0,
                                emailaddress1: this.Contact.emailaddress1,
                                telephone1: this.Contact.telephone1 == null ? this.Contact.dpa_authorizedperson_telephone : this.Contact.telephone1
                            };
                        }
                        return [4 /*yield*/, this.GetState()];
                    case 12:
                        State = _g.sent();
                        objSession = JSON.parse(localStorage.getItem('oneOTP'));
                        if (!(objSession != null)) return [3 /*break*/, 23];
                        v = localStorage.getItem("verifyIdentity");
                        if (!(v == "true")) return [3 /*break*/, 15];
                        thisTs_1.Util.ShowWaiting(true);
                        thisTs_1.Contact.dpa_allowemail = true;
                        thisTs_1.Contact.dpa_allowsms = thisTs_1.Contact.dpa_allowemail;
                        return [4 /*yield*/, thisTs_1.Api.post("crmservice", "contact", thisTs_1.Contact)];
                    case 13:
                        _g.sent();
                        //$("#divCondition").addClass("sr-only");
                        return [4 /*yield*/, thisTs_1.ShowBankList()];
                    case 14:
                        //$("#divCondition").addClass("sr-only");
                        _g.sent();
                        this.Util.ShowWaiting(false);
                        return [3 /*break*/, 22];
                    case 15:
                        if (!(thisTs_1.Contact.dpa_thaidflag != null && thisTs_1.Contact.dpa_thaidflag == true &&
                            thisTs_1.Contact.dpa_thaidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10))) return [3 /*break*/, 18];
                        thisTs_1.Util.ShowWaiting(true);
                        thisTs_1.Contact.dpa_allowemail = true;
                        thisTs_1.Contact.dpa_allowsms = thisTs_1.Contact.dpa_allowemail;
                        return [4 /*yield*/, thisTs_1.Api.post("crmservice", "contact", thisTs_1.Contact)];
                    case 16:
                        _g.sent();
                        return [4 /*yield*/, thisTs_1.ShowBankList()];
                    case 17:
                        _g.sent();
                        this.Util.ShowWaiting(false);
                        return [3 /*break*/, 22];
                    case 18:
                        if (!(thisTs_1.Contact.dpa_ndidflag != null && thisTs_1.Contact.dpa_ndidflag == true &&
                            thisTs_1.Contact.dpa_ndidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10))) return [3 /*break*/, 21];
                        thisTs_1.Util.ShowWaiting(true);
                        thisTs_1.Contact.dpa_allowemail = true;
                        thisTs_1.Contact.dpa_allowsms = thisTs_1.Contact.dpa_allowemail;
                        return [4 /*yield*/, thisTs_1.Api.post("crmservice", "contact", thisTs_1.Contact)];
                    case 19:
                        _g.sent();
                        return [4 /*yield*/, thisTs_1.ShowBankList()];
                    case 20:
                        _g.sent();
                        this.Util.ShowWaiting(false);
                        return [3 /*break*/, 22];
                    case 21:
                        //thisTs.Util.ShowWaiting(true);
                        //thisTs.Contact.dpa_allowemail = true;
                        //thisTs.Contact.dpa_allowsms = thisTs.Contact.dpa_allowemail;
                        //await thisTs.Api.post("crmservice", "contact", thisTs.Contact);
                        //$("#divCondition").addClass("sr-only");
                        //await thisTs.ShowBankList();
                        //thisTs.Util.ShowWaiting(false);
                        $("#divStart2").removeClass("sr-only");
                        _g.label = 22;
                    case 22: return [3 /*break*/, 24];
                    case 23:
                        if (this.OtpFlag == true) {
                            v = this.translate.get("Personal type");
                            $("#divOTP").removeClass("sr-only");
                            $("#CustomerType").html(v.value);
                            $("#divCompanyName").addClass("sr-only");
                            $("#divTaxID").addClass("sr-only");
                            v = this.translate.get("Name");
                            $("#lblFirstName").html(v.value);
                            v = this.translate.get("Surname");
                            $("#lblLastName").html(v.value);
                            $("#PhoneNo").html(this.Contact.telephone1);
                            if (this.Ticket.dpa_approvalstatuscode == '01' || this.Ticket.dpa_approvalstatuscode == '02') {
                                if (this.Ticket.dpa_approvalticketid == null) {
                                    this.Editable = true;
                                    $("#divDocList").removeAttr("disabled");
                                    $("#divUpload").removeClass("sr-only");
                                    $("#btnSendData").removeClass("sr-only");
                                }
                                else {
                                    $("#divDocList").attr("disabled", "disabled");
                                    $("#divUpload").addClass("sr-only");
                                }
                            }
                            else if (this.Ticket.dpa_approvalstatuscode == '05' || this.Ticket.dpa_approvalstatuscode == '06') {
                                $("#btnSendData").removeClass("sr-only");
                                if (this.Ticket.dpa_approvalstatuscode == '06') {
                                    $("#divDocList").removeAttr("disabled");
                                    $("#divUpload").removeClass("sr-only");
                                    this.Editable = true;
                                }
                            }
                        }
                        else {
                            localStorage.setItem("oneOTP", JSON.stringify(this.Contact));
                            $("#divOTP").addClass("sr-only");
                            this.SetState("skipotp");
                            if (this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "" ||
                                (this.Contact.dpa_dopaflag != null && this.Contact.dpa_dopaflag == true && this.Contact.dpa_dopaagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)) ||
                                (this.Contact.dpa_ndidflag != null && this.Contact.dpa_ndidflag == true && this.Contact.dpa_ndidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)) ||
                                (this.Contact.dpa_thaidflag != null && this.Contact.dpa_thaidflag == true && this.Contact.dpa_thaidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10))) {
                                this.otpSkip = true;
                            }
                            else {
                                if ((this.Contact.dpa_companytypeid == null || this.Contact.dpa_companytypeid == "")) {
                                    $("#btnDOPAParent").removeClass("sr-only");
                                    ////$("#btnNDIDParent").addClass("sr-only");
                                    // $("#btnDOPAParent").removeClass("mr-3");
                                    //$("#btnByAgentBank").removeClass("ml-3");
                                }
                                //else if (this.Contact.dpa_companytypeid == null || this.Contact.dpa_companytypeid == "") {
                                //  $("#btnDOPAParent").removeClass("sr-only");
                                //$("#btnNDIDParent").removeClass("sr-only");
                                //$("#btnByAgentBankParent").removeClass("sr-only");
                                //}
                                $("#divStart2").removeClass("sr-only");
                            }
                        }
                        _g.label = 24;
                    case 24:
                        if (State != "") {
                            this.GotoState(State);
                        }
                        TableDocs = $('#TableDocs');
                        TableDocs.on('click', 'tbody tr td [role=view]', function () {
                            thisTs_1.ViewDoc($(this).attr('url'), $(this).attr('filename'));
                        });
                        TableDocs.on('click', 'tbody tr td [role=delete]', function () {
                            thisTs_1.DeleteDoc($(this).attr('filename'), $(this).attr('annotationid'));
                        });
                        this.AcceptExtension = environment.AcceptUploadFileExtension;
                        _f = this;
                        return [4 /*yield*/, this.MasterService.GetMaxUploadFileSize()];
                    case 25:
                        _f.MaxTotalSizeMB = _g.sent();
                        if (!(this.otpSkip == true)) return [3 /*break*/, 27];
                        return [4 /*yield*/, this.ShowConsentForm()];
                    case 26:
                        _g.sent();
                        _g.label = 27;
                    case 27: return [3 /*break*/, 29];
                    case 28:
                        this.Util.ShowWaiting(false);
                        this.Util.WarningDialog("กรุณาเข้าสู่ระบบ");
                        $("#btnWarningOK").off("click");
                        $("#btnWarningOK").click(function () {
                            thisTs_1.router.navigate(["/mainmenu/login"]);
                        });
                        _g.label = 29;
                    case 29: return [3 /*break*/, 31];
                    case 30:
                        e_1 = _g.sent();
                        this.Util.ShowWaiting(false);
                        console.log(e_1);
                        this.Util.ErrorDialog("เกิดข้อผิดพลาด กรูณาติดต่อเจ้าหน้าที่");
                        return [3 /*break*/, 31];
                    case 31: return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.StartProcess = function (DOPA) {
        if (DOPA === void 0) { DOPA = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.Util.ShowWaiting(true);
                        if (!(this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "")) return [3 /*break*/, 4];
                        $("#divStart").addClass("sr-only");
                        if (!(this.Ticket.dpa_approvalstatuscode == '03')) return [3 /*break*/, 1];
                        $("#PhoneNo").html(this.Contact.dpa_authorizedperson_telephone);
                        $("#divOTP").removeClass("sr-only");
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.ShowDetails()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 10];
                    case 4:
                        if (!DOPA) return [3 /*break*/, 5];
                        if ($("#FirstNameDOPA").val() == "" || $("#LastNameDOPA").val() == "" || $("#IDNoDOPA").val() == "" || $("#LaserNoDOPA").val() == "" || $("#BirthDateDOPA").val() == "") {
                            this.Util.WarningDialog("กรุณากรอกข้อมูลบังคับ (*) ให้ครบถ้วน");
                            this.Util.ShowWaiting(false);
                            return [2 /*return*/];
                        }
                        // let reqDopa:any = {
                        //   request_number: "000001",
                        //   service_code: "0001", 
                        //   pid: $("#IDNoDOPA").val(),
                        //   firstname: $("#FirstNameDOPA").val(),
                        //   lastname: $("#LastNameDOPA").val(),
                        //   birthday: $("#BirthDateDOPA").val(),
                        //   laser: $("#LaserNoDOPA").val()
                        // }
                        // let resDopa: any = await this.Api.checkCard(reqDopa)
                        // if(resDopa != null && resDopa.code == 0){
                        //   let ParamObj = {
                        //     dpa_dopaflag: true,
                        //     // dpa_dopaagingdate: this.AddDays(new Date(), 180).toISOString().replace("Z", "").replace("z", "")
                        //     dpa_dopaagingdate: new Date().toISOString()
                        //   };
                        //   let Res = await this.Api.put("crmservice", "contact-dopaflag-aging/" + this.Contact.contactid, ParamObj);
                        //   this.Contact = await (this.Api.get("crmservice", "contact", "contactid=" + this.Profile.customerid));
                        //   this.Contact = this.Contact[0]
                        this.SubmitOTP(true);
                        return [3 /*break*/, 9];
                    case 5:
                        if (!(this.Ticket.dpa_approvalstatuscode == '03')) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.SubmitOTP()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.ShowDetails()];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        $("#divStart2").addClass("sr-only");
                        _a.label = 10;
                    case 10:
                        this.Util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.DOPA = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                $("#divStart2").addClass("sr-only");
                $("#divDOPA").removeClass("sr-only");
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.OpenNDID = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                location.href = "webpage.html";
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.AddDays = function (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    };
    RefundDepositsComponent.prototype.InvestigateAndAppealStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.drosWeb != "") {
                    window.open(this.drosWeb, "_blank");
                }
                else {
                    this.Util.WarningDialog("ไม่สามารถดำเนินการยื่นอุธรณ์ได้");
                }
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.ShowDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var firstname, lastname, name_1, i, firstname, lastname, name_2, i, v, onlydate, thisTs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $("#TicketNo").val(this.Ticket.dpa_name);
                        if (this.Ticket.dpa_personaltypeid == null) {
                            $("#CompanyType").val(this.Ticket.dpa_companytypeidname);
                        }
                        else {
                            $("#CompanyType").val(this.Ticket.dpa_personaltypeidname);
                        }
                        $("#CompanyName").val(this.Ticket.dpa_contactidname);
                        $("#RegistrationID").val(this.Ticket.dpa_registrationid);
                        if (this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "") {
                            firstname = "";
                            lastname = "";
                            name_1 = this.Ticket.dpa_contactidname.split(" ");
                            if (name_1.length > 0) {
                                if (name_1.length == 1) {
                                    firstname = name_1[0];
                                }
                                else if (name_1.length == 2) {
                                    firstname = name_1[0];
                                    lastname = name_1[1];
                                }
                                else {
                                    for (i = 0; i < name_1.length - 1; i++) {
                                        firstname += " " + name_1[i];
                                    }
                                    firstname = firstname.trim();
                                    lastname = name_1[name_1.length - 1];
                                }
                            }
                            $("#FirstName").val(firstname);
                            $("#LastName").val(lastname);
                            $("#CitizenID").val(this.Ticket.dpa_authorizedperson_idcard);
                        }
                        else {
                            firstname = "";
                            lastname = "";
                            name_2 = this.Ticket.dpa_contactidname.split(" ");
                            if (name_2.length > 0) {
                                if (name_2.length == 1) {
                                    firstname = name_2[0];
                                }
                                else if (name_2.length == 2) {
                                    firstname = name_2[0];
                                    lastname = name_2[1];
                                }
                                else {
                                    for (i = 0; i < name_2.length - 1; i++) {
                                        firstname += " " + name_2[i];
                                    }
                                    firstname = firstname.trim();
                                    lastname = name_2[name_2.length - 1];
                                }
                            }
                            $("#FirstName").val(firstname);
                            $("#LastName").val(lastname);
                            $("#CitizenID").val(this.Ticket.dpa_idcard);
                        }
                        v = this.translate.get("Send");
                        onlydate = 'รองรับเฉพาะไฟล์ประเภท ' + this.AcceptExtension + ' ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB";
                        $("#onlydata").html(onlydate);
                        $("#Remark").val(this.Ticket.dpa_remark);
                        $("#btnSendData").html(v.value);
                        v = this.translate.get("Upload documents");
                        switch (this.Ticket.dpa_approvalstatuscode) {
                            case '01':
                                $("#Status").val("In Progress");
                                break;
                            case '02':
                                $("#Status").val("Wait");
                                break;
                            case '03':
                                $("#Status").val("Approved");
                                break;
                            case '05':
                                $("#Status").val("Rejected");
                                $("#btnSendData").html(v.value);
                                break;
                            case '06':
                                $("#Status").val("Rejected (Edit Docs)");
                                break;
                            default: break;
                        }
                        return [4 /*yield*/, this.CreateDocumentList()];
                    case 1:
                        _a.sent();
                        this.TotalFileSize = 0;
                        this.Ticket.attachfilelist.forEach(function (a) {
                            var Decoded = atob(a.documentbody);
                            a.filesize = Decoded.length;
                            _this.TotalFileSize += a.filesize;
                            a.url = "data:" + a.mimetype + ";base64," + a.documentbody;
                        });
                        this.FileList = this.Ticket.attachfilelist;
                        return [4 /*yield*/, this.CreateTableFile()];
                    case 2:
                        _a.sent();
                        thisTs = this;
                        $('.docCheck').on("change", function (e) {
                            thisTs.SelectDocument(e.target);
                        });
                        $("#divDetails").removeClass("sr-only");
                        return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.CreateDocumentList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, _b, Selected, i, DivContent, SeqNo, Checked;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.Ticket.dpa_personaltypeid == null)) return [3 /*break*/, 3];
                        if (!(this.CompanyType == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.Api.get("master", "companyType")];
                    case 1:
                        _a.CompanyType = _c.sent();
                        _c.label = 2;
                    case 2:
                        this.DocGroupList = this.CompanyType.filter(function (a) { return a.dpa_companytypeid == _this.Ticket.dpa_companytypeid; })[0].dpa_documentgrouplist;
                        return [3 /*break*/, 6];
                    case 3:
                        if (!(this.PersonalType == null)) return [3 /*break*/, 5];
                        _b = this;
                        return [4 /*yield*/, this.Api.get("master", "personalType")];
                    case 4:
                        _b.PersonalType = _c.sent();
                        _c.label = 5;
                    case 5:
                        this.DocGroupList = this.PersonalType.filter(function (a) { return a.dpa_personaltypeid == _this.Ticket.dpa_personaltypeid; })[0].dpa_documentgrouplist;
                        _c.label = 6;
                    case 6:
                        this.DocumentList = [];
                        if (this.Ticket.dpa_documentchecklist != null && this.Ticket.dpa_documentchecklist != "") {
                            Selected = this.Ticket.dpa_documentchecklist.split("|");
                            for (i = 0; i < Selected.length; i++) {
                                this.DocumentList.push({
                                    "dpa_documentid": Selected[i]
                                });
                            }
                        }
                        $("#divDocList").empty();
                        DivContent = '<br />';
                        SeqNo = 1;
                        Checked = "";
                        // this.DocGroupList.forEach((DocGroup: any) => {
                        //   DocGroup["dpa_documentlist"].forEach((Doc: any) => {
                        //     Checked = this.DocumentList.length == 0 ? "" : this.Ticket.dpa_documentchecklist.includes(Doc.dpa_documentid) ? " checked" : "";
                        //     DivContent += '<label class="checktable">';
                        //     DivContent += ' <input type="checkbox" class="docCheck" value="' + Doc.dpa_documentid + '"' + Checked + '><span class="checkmark"></span>';
                        //     DivContent += ' <label>' + SeqNo + '. ' + Doc.dpa_name + '</label>';
                        //     DivContent += '</label>';
                        //     SeqNo++;
                        //   });
                        // });
                        this.DocGroupList.forEach(function (DocGroup) {
                            Checked = _this.DocumentList.length == 0 ? "" : _this.Ticket.dpa_documentchecklist.includes(DocGroup.dpa_documentgroupid) ? " checked" : "";
                            DivContent += '<label class="checktable">';
                            DivContent += ' <input type="checkbox" class="docCheck" value="' + DocGroup.dpa_documentgroupid + '"' + Checked + '><span class="checkmark"></span>';
                            DivContent += ' <label>' + SeqNo + '. ' + DocGroup.dpa_name + '</label>';
                            DivContent += '</label>';
                            SeqNo++;
                        });
                        $("#divDocList").append(DivContent);
                        return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.CreateTableFile = function () {
        var thisTs = this;
        var TableDocs = $('#TableDocs').DataTable({
            "paging": false,
            "bFilter": false,
            "info": false,
            "data": thisTs.FileList,
            "columns": [
                { "data": "filename", "class": "text-center" },
                { "data": "filename" },
                {
                    "data": "filesize",
                    "render": function (data, type, row) {
                        if (row.filesize / 1024 / 1024 < 1) {
                            return Math.floor(row.filesize / 1024) + ' KB';
                        }
                        else {
                            return (Math.round(row.filesize / 1024 / 1024 * 100 + Number.EPSILON) / 100) + ' MB';
                        }
                    },
                    "class": "text-right"
                },
                {
                    "data": null,
                    "render": function (data, type, row) {
                        return '<i class="fa fa-eye editicon cursorpointer" role="view" url="' + row.url + '" filename="' + row.filename + '" title="View"></i>' +
                            (thisTs.Editable ? '<i class="fa fa-times deleteicon cursorpointer" role="delete" filename="' + row.filename + '" annotationid="' + row.annotationid + '" title="Delete"></i>' : '');
                    },
                    "class": "col-btn-2 text-center"
                }
            ],
            "language": {
                "zeroRecords": "ยังไม่ได้อัปโหลดไฟล์"
            }
        });
        TableDocs.on('order.dt search.dt', function () {
            TableDocs.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell, i) {
                cell.innerHTML = i + 1;
            });
        }).destroy().draw();
    };
    RefundDepositsComponent.prototype.SelectDocument = function (target) {
        if (target.checked) {
            if (this.DocumentList == null || this.DocumentList == undefined)
                this.DocumentList = [];
            this.DocumentList.push({
                "dpa_documentid": target.value,
            });
        }
        else {
            this.DocumentList = this.DocumentList.filter(function (a) { return a.dpa_documentid != target.value; });
        }
    };
    RefundDepositsComponent.prototype.ViewDoc = function (Url, FileName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (Url == "") {
                    this.Util.ErrorDialog('ไม่พบไฟล์ที่เลือก');
                    return [2 /*return*/];
                }
                window.open(this.Util.CreateBlobUrl(Url), "_blank");
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.DeleteDoc = function (FileName, AnnotationID) {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                thisTs = this;
                this.Util.ConfirmDialog("คุณต้องการลบไฟล์เอกสารแนบใช่หรือไม่?");
                $("#btnMainConfirm").off('click');
                $("#btnMainConfirm").click(function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var DelObj;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(AnnotationID != null && AnnotationID != "" && AnnotationID != "null")) return [3 /*break*/, 2];
                                    DelObj = {
                                        annotationid: AnnotationID
                                    };
                                    return [4 /*yield*/, thisTs.Api.post("crmservice", "delAnnotation2", DelObj)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    thisTs.FileList.forEach(function (item, index) {
                                        if (item["filename"] === FileName)
                                            thisTs.FileList.splice(index, 1);
                                    });
                                    thisTs.CreateTableFile();
                                    return [2 /*return*/];
                            }
                        });
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.FileSelect = function (File) {
        return __awaiter(this, void 0, void 0, function () {
            var FileName, FileExtension, TotalFileSize, FR, FileContent, MimeType, thisTs;
            return __generator(this, function (_a) {
                if (File.length == 0)
                    return [2 /*return*/];
                FileName = File[0]["name"];
                FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length);
                if (!this.AcceptExtension.includes(FileExtension.toLowerCase())) {
                    this.Util.ErrorDialog('รองรับเฉพาะไฟล์ ' + this.AcceptExtension);
                    $('#fileAttach').val('');
                    return [2 /*return*/];
                }
                TotalFileSize = File[0]["size"];
                this.FileList.forEach(function (a) {
                    TotalFileSize += +a["filesize"];
                });
                if (TotalFileSize / 1024 / 1024 > this.MaxTotalSizeMB) {
                    this.Util.ErrorDialog('ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB");
                    $('#fileAttach').val('');
                    return [2 /*return*/];
                }
                if (this.FileList != null) {
                    if (this.FileList.filter(function (a) { return a.filename == File[0].name; }).length > 0) {
                        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
                        return [2 /*return*/];
                    }
                }
                FR = new FileReader();
                thisTs = this;
                FR.onload = function (e) {
                    var t = e.target;
                    FileContent = t.result;
                    MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
                    var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);
                    if (thisTs.FileList == null || thisTs.FileList == undefined)
                        thisTs.FileList = [];
                    thisTs.FileList.push({
                        "annotationid": null,
                        "filename": File[0].name,
                        "documentbody": FileContent2,
                        "mimetype": MimeType,
                        "filesize": File[0]["size"],
                        "url": FileContent
                    });
                    $('#fileAttach').val('');
                    // $('#txtFileName').val('');
                    thisTs.CreateTableFile();
                };
                FR.readAsDataURL(File[0]);
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.UploadFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var FileInput, File, FileContent, MimeType, thisTs;
            return __generator(this, function (_a) {
                FileInput = $('#fileAttach')[0]["files"];
                if (FileInput.length == 0) {
                    this.Util.ErrorDialog('กรุณาเลือกไฟล์');
                    return [2 /*return*/];
                }
                if (this.FileList != null) {
                    if (this.FileList.filter(function (a) { return a.filename == FileInput[0].name; }).length > 0) {
                        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
                        return [2 /*return*/];
                    }
                }
                File = new FileReader();
                thisTs = this;
                File.onload = function (e) { return __awaiter(_this, void 0, void 0, function () {
                    var t, FileContent2, T;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                t = e.target;
                                FileContent = t.result;
                                MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
                                FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);
                                if (thisTs.FileList == null || thisTs.FileList == undefined)
                                    thisTs.FileList = [];
                                thisTs.FileList.push({
                                    "annotationid": null,
                                    "filename": FileInput[0].name,
                                    "documentbody": FileContent2,
                                    "mimetype": MimeType,
                                    "filesize": FileInput[0]["size"],
                                    "url": FileContent
                                });
                                this.TotalFileSize += +FileInput[0]["size"];
                                $('#fileAttach').val('');
                                $('#txtFileName').val('');
                                if (!(thisTs.Ticket.dpa_approvalstatuscode == '02')) return [3 /*break*/, 3];
                                thisTs.Ticket.attachfilelist = thisTs.FileList;
                                thisTs.Ticket["dpa_approvalstatusid"] = thisTs.GetStatusGuidByCode(thisTs.Ticket.dpa_approvalstatuscode);
                                return [4 /*yield*/, thisTs.Api.post("crmservice", "approvalticket", thisTs.Ticket)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, thisTs.Api.get("crmservice", "searchapprovalticket", "ticketno=" + thisTs.Ticket.dpa_name)];
                            case 2:
                                T = _a.sent();
                                thisTs.Ticket = T[0];
                                thisTs.Ticket.attachfilelist.forEach(function (a) {
                                    var Decoded = atob(a.documentbody);
                                    a.filesize = Decoded.length;
                                    a.url = "data:" + a.mimetype + ";base64," + a.documentbody;
                                });
                                thisTs.FileList = thisTs.Ticket.attachfilelist;
                                _a.label = 3;
                            case 3:
                                thisTs.CreateTableFile();
                                return [2 /*return*/];
                        }
                    });
                }); };
                File.readAsDataURL(FileInput[0]);
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.SendData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var thisTs_2, IsValid, DocList, Res, _a, LastDate_2, TmpTicket_2, thisTs, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.Ticket.dpa_statdpa_approvalstatuscodeus == '05' && !this.Editable)) return [3 /*break*/, 3];
                        this.Util.ShowWaiting(true);
                        $("#divDocList").removeAttr("disabled");
                        $("#divUpload").removeClass("sr-only");
                        $("#btnSendData").html("ยืนยันส่งข้อมูล");
                        this.Editable = true;
                        this.Ticket.dpa_documentchecklist = "";
                        this.Ticket.attachfilelist = [];
                        this.FileList = [];
                        return [4 /*yield*/, this.CreateDocumentList()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.CreateTableFile()];
                    case 2:
                        _b.sent();
                        thisTs_2 = this;
                        $('.docCheck').on("change", function (e) {
                            thisTs_2.SelectDocument(e.target);
                        });
                        this.Util.ShowWaiting(false);
                        return [2 /*return*/];
                    case 3:
                        if (this.FileList.length == 0) {
                            this.Util.WarningDialog("กรุณาอัปโหลดไฟล์เอกสาร");
                            return [2 /*return*/];
                        }
                        if (this.DocumentList.length == 0) {
                            this.Util.WarningDialog("กรุณาเลือกประเภทเอกสาร");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.ValidateSelectedDocument(this.DocumentList, this.DocGroupList)];
                    case 4:
                        IsValid = _b.sent();
                        if (!IsValid)
                            return [2 /*return*/];
                        this.Util.ShowWaiting(true);
                        if (this.Ticket.dpa_approvalstatuscode == '05') {
                            this.Ticket.dpa_approvalstatuscode = '01';
                            this.Ticket.dpa_approvalticketid = null;
                            this.Ticket.dpa_name = null;
                            this.Ticket.dpa_originalsource = 1;
                            this.Ticket.dpa_remark = "";
                            this.Ticket.dpa_submitdate = new Date();
                        }
                        else {
                            this.Ticket.dpa_submitdate = this.Ticket.dpa_submitdate.substring(0, 10);
                            this.Ticket.dpa_approvalstatuscode = '01';
                        }
                        DocList = "";
                        this.DocumentList.forEach(function (a) {
                            DocList += (DocList == "" ? "" : "|") + a.dpa_documentid;
                        });
                        this.Ticket.attachfilelist = this.FileList;
                        this.Ticket.dpa_documentchecklist = DocList;
                        this.TotalFileSize = 0;
                        this.Ticket.attachfilelist.forEach(function (a) {
                            var Decoded = atob(a.documentbody);
                            a.filesize = Decoded.length;
                            _this.TotalFileSize += a.filesize;
                            a.url = "";
                        });
                        this.Ticket.dpa_attachsizing = this.TotalFileSize;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 8, , 9]);
                        this.Ticket["dpa_approvalstatusid"] = this.GetStatusGuidByCode(this.Ticket.dpa_approvalstatuscode);
                        return [4 /*yield*/, this.Api.post("crmservice", "approvalticket", this.Ticket)];
                    case 6:
                        Res = _b.sent();
                        _a = this;
                        return [4 /*yield*/, (this.Api.get("crmservice", "searchApprovalTicket", "contactid=" + this.Profile.customerid))];
                    case 7:
                        _a.Ticket = _b.sent();
                        if (this.Ticket.length > 1) {
                            this.Ticket.forEach(function (a) {
                                if (LastDate_2 == null || LastDate_2 == undefined) {
                                    LastDate_2 = new Date(a.dpa_submitdate);
                                    TmpTicket_2 = a;
                                }
                                else {
                                    if (LastDate_2 < new Date(a.dpa_submitdate)) {
                                        LastDate_2 = new Date(a.dpa_submitdate);
                                        TmpTicket_2 = a;
                                    }
                                }
                            });
                            this.Ticket = TmpTicket_2;
                        }
                        else {
                            this.Ticket = this.Ticket[0];
                        }
                        if (this.Ticket.dpa_approvalstatuscode == "01") {
                            $("#TicketNo").val(this.Ticket.dpa_name);
                            this.Editable = false;
                            this.ShowDetails();
                            $("#btnSendData").addClass("sr-only");
                            this.Util.SuccessDialog("ส่งข้อมูลสำเร็จ");
                        }
                        else {
                            this.Util.SuccessDialog("อัปโหลดเอกสารยืนยันตัวตนสำเร็จ กรุณาตรวจสอบการอนุมัติเอกสารได้ที่อีเมลของท่าน");
                        }
                        thisTs = this;
                        $("#btnSuccessOK").off('click');
                        $("#btnSuccessOK").click(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/];
                                });
                            });
                        });
                        return [3 /*break*/, 9];
                    case 8:
                        err_1 = _b.sent();
                        console.log(err_1);
                        this.Util.WarningDialog("ไม่สามารถบันทึกข้อมูลได้");
                        return [3 /*break*/, 9];
                    case 9:
                        this.Util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.BackToHome = function () {
        this.router.navigate(["/mainmenu/index"]);
        // $("#divStart").removeClass("sr-only");
        // if (!$("#divDetails").hasClass("sr-only")) {
        //   $("#divDetails").addClass("sr-only")
        // }
        // if (!$("#divOTP").hasClass("sr-only")) {
        //   $("#divOTP").addClass("sr-only")
        // }
        // if (!$("#divCondition").hasClass("sr-only")) {
        //   $("#divCondition").addClass("sr-only")
        // }
        // if (!$("#divBankList").hasClass("sr-only")) {
        //   $("#divBankList").addClass("sr-only")
        // }
        // if (!$("#divSummary").hasClass("sr-only")) {
        //   $("#divSummary").addClass("sr-only")
        // }
    };
    RefundDepositsComponent.prototype.ValidateSelectedDocument = function (Selected, DocGroup) {
        return __awaiter(this, void 0, void 0, function () {
            var ItemFound, IsValid, Msg, Msg2;
            return __generator(this, function (_a) {
                if (Selected == null || Selected == undefined || Selected.length == 0)
                    return [2 /*return*/, false];
                IsValid = true;
                Msg = "", Msg2 = "";
                DocGroup.forEach(function (DocList) {
                    ItemFound = false;
                    Msg2 = "";
                    // DocList.dpa_documentlist.forEach((Doc: any) => {
                    //   Selected.forEach((a: any) => {
                    //     if (a.dpa_documentid == Doc.dpa_documentid) {
                    //       ItemFound = true;
                    //     }
                    //   });
                    //   Msg2 += (Msg2 == "" ? "" : " หรือ ") + Doc.dpa_name;
                    // });
                    Selected.forEach(function (a) {
                        if (a.dpa_documentid == DocList.dpa_documentgroupid) {
                            ItemFound = true;
                        }
                    });
                    Msg2 = DocList.dpa_name;
                    if (!ItemFound) {
                        IsValid = false;
                        Msg += (Msg == "" ? "" : " และ ") + Msg2;
                    }
                });
                if (!IsValid)
                    this.Util.WarningDialog("กรุณาเลือก" + Msg);
                return [2 /*return*/, IsValid];
            });
        });
    };
    RefundDepositsComponent.prototype.SubmitOTP = function (ToBankList) {
        if (ToBankList === void 0) { ToBankList = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        /*let State = await this.GetState();
                        if ($("#OTP").val() == "") {
                          if (State == "") {
                            this.Util.WarningDialog("กรุณาระบุรหัส OTP");
                            $("#btnWarningOK").off("click");
                            $("#btnWarningOK").click(function () {
                              setTimeout(() => {
                                $("#OTP").focus();
                              }, 200);
                            });
                            return;
                          }
                        }
                    
                        if (ToBankList == false && State == "") {
                          let ParamObj: any = {
                            OTP: $("#OTP").val(),
                            RefCode: this.OTPRefCode,
                            MobileNo: this.Contact.telephone1
                          };
                          let Res: any = await this.Api.postCustomApi("Crm", "VerifyOTP", ParamObj);
                          if (!this.Util.isSuccessResponse(Res)) {
                            this.Util.WarningDialog("เกิดข้อผิดพลาดระหว่างตรวจสอบ OTP กรุณาติดต่อผู้ดูแลระบบ");
                            return;
                          }
                          if (Res.IsValid == false) {
                            this.Util.WarningDialog("รหัส OTP ไม่ถูกต้อง");
                            return;
                          }
                        }*/
                        localStorage.setItem("oneOTP", JSON.stringify(this.Contact));
                        $("#divOTP").addClass("sr-only");
                        this.SetState("skipotp");
                        if (!(this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "" ||
                            (this.Contact.dpa_dopaflag != null && this.Contact.dpa_dopaflag == true && this.Contact.dpa_dopaagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)) ||
                            (this.Contact.dpa_ndidflag != null && this.Contact.dpa_ndidflag == true && this.Contact.dpa_ndidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)) ||
                            (this.Contact.dpa_thaidflag != null && this.Contact.dpa_thaidflag == true && this.Contact.dpa_thaidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.ShowConsentForm()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if ((this.Contact.dpa_companytypeid == null || this.Contact.dpa_companytypeid == "")) {
                            $("#btnDOPAParent").removeClass("sr-only");
                            ////$("#btnNDIDParent").addClass("sr-only");
                            // $("#btnDOPAParent").removeClass("mr-3");
                            //$("#btnByAgentBank").removeClass("ml-3");
                        }
                        //else if (this.Contact.dpa_companytypeid == null || this.Contact.dpa_companytypeid == "") {
                        //  $("#btnDOPAParent").removeClass("sr-only");
                        //$("#btnNDIDParent").removeClass("sr-only");
                        //$("#btnByAgentBankParent").removeClass("sr-only");
                        //}
                        $("#divStart2").removeClass("sr-only");
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.ShowConsentForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                $("#divCondition").removeClass("sr-only");
                $("#divDOPA").addClass("sr-only");
                thisTs = this;
                $("#Accept").off('click');
                $("#Accept").click(function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var v;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!$("#Accepted")[0].checked) {
                                        thisTs.Util.WarningDialog("กรุณายอมรับเงื่อนไข");
                                        return [2 /*return*/];
                                    }
                                    thisTs.Util.ShowWaiting(true);
                                    // let BankList: any = await thisTs.Api.get("master", "bank");
                                    // let Bank: any;
                                    // let EffectiveDate: any = "-";
                                    // let CardList: any = "";
                                    // $("#divBankCard").empty();
                                    // if (thisTs.ContactDros.CRM07 == null || thisTs.ContactDros.CRM07 == undefined) {
                                    //   thisTs.Util.ShowWaiting(false);
                                    //   thisTs.Util.WarningDialog("ไม่พบข้อมูล");
                                    //   return;
                                    // }
                                    // thisTs.ContactDros.CRM07.forEach(async (a: any) => {
                                    //   Bank = BankList.filter((b: any) => b.dpa_bankcode == a.BankCode)[0];
                                    //   if (Bank.dpa_effectivedate != null && Bank.dpa_effectivedate != "") {
                                    //     EffectiveDate = new Date(Bank.dpa_effectivedate.substring(0, 10));
                                    //     EffectiveDate = thisTs.Util.ConvertToBE(EffectiveDate.getDate() + "/" + (EffectiveDate.getMonth() + 1) + "/" + EffectiveDate.getFullYear());
                                    //   }
                                    //   CardList = '<div class="row mt-3">' +
                                    //     '  <div class="col-12 centered-content">' +
                                    //     '    <button class="btn bank-card" id="' + a.BankCode + '">' +
                                    //     '      <i class="fas fa-chevron-right bank-card-arrow"></i>' +
                                    //     '      <img class="bank-card-icon" src="../../assets/images/bank.png">' +
                                    //     '      <div class="text-left bank-card-title">' +
                                    //     '        <span>' + Bank.dpa_name + '</span>' +
                                    //     '      </div>' +
                                    //     '      <div class="text-left bank-card-info1">' +
                                    //     '        <span>' +
                                    //     '          <img src="../../assets/images/warning.png">' +
                                    //     '          Effective: ' + EffectiveDate +
                                    //     '        </span>' +
                                    //     '      </div>' +
                                    //     '      <div class="text-left bank-card-info2">' +
                                    //     '        <span>เบอร์โทรติดต่อ: ' + (Bank.dpa_telephoneno == null || Bank.dpa_telephoneno == "" ? "-" : Bank.dpa_telephoneno) + '</span>' +
                                    //     '      </div>' +
                                    //     '    </button>' +
                                    //     '  </div>' +
                                    //     '</div>';
                                    //   $("#divBankCard").append(CardList);
                                    //   $("#" + a.BankCode).off("click");
                                    //   $("#" + a.BankCode).click(async function () {
                                    //     thisTs.ViewSummary(a.BankCode);
                                    //   });
                                    // });
                                    // boy comment out
                                    thisTs.Contact.dpa_allowemail = true; //$("#ReceiveNews")[0].checked;
                                    thisTs.Contact.dpa_allowsms = thisTs.Contact.dpa_allowemail;
                                    return [4 /*yield*/, thisTs.Api.post("crmservice", "contact", thisTs.Contact)];
                                case 1:
                                    _a.sent();
                                    //localStorage.setItem("oneOTP", JSON.stringify(thisTs.Contact))
                                    $("#divCondition").addClass("sr-only");
                                    v = localStorage.getItem("verifyIdentity");
                                    if (!(v == "true")) return [3 /*break*/, 3];
                                    // $("#divBankList").removeClass("sr-only");
                                    return [4 /*yield*/, thisTs.ShowBankList()];
                                case 2:
                                    // $("#divBankList").removeClass("sr-only");
                                    _a.sent();
                                    return [3 /*break*/, 8];
                                case 3:
                                    if (!(thisTs.Contact.dpa_thaidflag != null && thisTs.Contact.dpa_thaidflag == true &&
                                        thisTs.Contact.dpa_thaidagingdate != null && thisTs.Contact.dpa_thaidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10))) return [3 /*break*/, 5];
                                    return [4 /*yield*/, thisTs.ShowBankList()];
                                case 4:
                                    _a.sent();
                                    return [3 /*break*/, 8];
                                case 5:
                                    if (!(thisTs.Contact.dpa_ndidflag != null && thisTs.Contact.dpa_ndidflag == true &&
                                        thisTs.Contact.dpa_ndidagingdate != null && thisTs.Contact.dpa_ndidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10))) return [3 /*break*/, 7];
                                    return [4 /*yield*/, thisTs.ShowBankList()];
                                case 6:
                                    _a.sent();
                                    return [3 /*break*/, 8];
                                case 7:
                                    // $("#divBankList").removeClass("sr-only");
                                    //await thisTs.ShowBankList();
                                    $("#divStart2").removeClass("sr-only");
                                    _a.label = 8;
                                case 8:
                                    thisTs.Util.ShowWaiting(false);
                                    return [2 /*return*/];
                            }
                        });
                    });
                });
                $("#Reject").off('click');
                $("#Reject").click(function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            $("#divCondition").addClass("sr-only");
                            $("#divOTP").removeClass("sr-only");
                            return [2 /*return*/];
                        });
                    });
                });
                this.SetState("consent");
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.ShowBankList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var BankList, Bank, EffectiveDate, CardList, thisTs, crm07;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.Api.get("master", "bank")];
                    case 1:
                        BankList = _a.sent();
                        EffectiveDate = "-";
                        CardList = "";
                        thisTs = this;
                        $("#divBankCard").empty();
                        if (this.ContactDros.CRM07 == null || this.ContactDros.CRM07 == undefined) {
                            this.Util.ShowWaiting(false);
                            this.Util.WarningDialog("ไม่พบข้อมูล");
                            return [2 /*return*/];
                        }
                        crm07 = [];
                        this.ContactDros.CRM07.forEach(function (c) {
                            var found = crm07.filter(function (t) {
                                return c.BankCode == t.BankCode;
                            });
                            if (found == null || found.length == 0) {
                                crm07.push(c);
                            }
                        });
                        crm07.forEach(function (a) { return __awaiter(_this, void 0, void 0, function () {
                            var v, ve;
                            return __generator(this, function (_a) {
                                Bank = BankList.filter(function (b) { return b.dpa_bankcode == a.BankCode; })[0];
                                if (Bank.dpa_effectivedate != null && Bank.dpa_effectivedate != "") {
                                    EffectiveDate = new Date(Bank.dpa_effectivedate.substring(0, 10));
                                    EffectiveDate = this.Util.ConvertToBE(EffectiveDate.getDate() + "/" + (EffectiveDate.getMonth() + 1) + "/" + EffectiveDate.getFullYear());
                                }
                                v = this.translate.get("Phone no.");
                                ve = this.translate.get("Effective Date");
                                CardList = '<div class="row mt-3">' +
                                    '  <div class="col-12 centered-content">' +
                                    '    <button class="btn bank-card view-summary-btn" id="' + a.BankCode + '">' +
                                    '      <i class="fas fa-chevron-right bank-card-arrow"></i>' +
                                    '      <img class="bank-card-icon" src="../../assets/images/bank.png">' +
                                    '      <div class="text-left bank-card-title">' +
                                    '        <span>' + Bank.dpa_name + '</span>' +
                                    '      </div>' +
                                    '      <div class="text-left bank-card-info1">' +
                                    '        <span>' +
                                    '          <img src="../../assets/images/warning.png">' +
                                    '          ' + ve.value + ': ' + EffectiveDate +
                                    '        </span>' +
                                    '      </div>' +
                                    '      <div class="text-left bank-card-info2">' +
                                    '        <span>' + v.value + ': ' + (Bank.dpa_telephoneno == null || Bank.dpa_telephoneno == "" ? "-" : Bank.dpa_telephoneno) + '</span>' +
                                    '      </div>' +
                                    '    </button>' +
                                    '  </div>' +
                                    '</div>';
                                $("#divBankCard").append(CardList);
                                $("#" + a.BankCode).off("click");
                                // $("#" + a.BankCode).click(async function () {
                                //   thisTs.ViewSummary(a.BankCode);
                                // });
                                $(".view-summary-btn").click(function () {
                                    return __awaiter(this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            thisTs.ViewSummary(this.id);
                                            return [2 /*return*/];
                                        });
                                    });
                                });
                                return [2 /*return*/];
                            });
                        }); });
                        //$("#divBankList").removeClass("sr-only");
                        this.SetState("banklist");
                        $(".view-summary-btn").click();
                        return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.ViewSummary = function (BankCode) {
        return __awaiter(this, void 0, void 0, function () {
            var NoOfAcc, NetReimbursible, TaxAmount, LastDate, Rec03, Rec04, Rec05, Rec06, res04_type01, res04_type02, res04_type03, res04_type04, res04_type05, StatusText1, v, StatusText2, v, StatusText3, v, StatusText4, res05Type04, v, res05Type04, StatusText4, StatusText5, res05Type05, v, res05Type05, StatusText5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.ContactDros.CRM06 == null) {
                            this.Util.WarningDialog("ไม่มีข้อมูลรายละเอียดเงินฝากของท่าน");
                            return [2 /*return*/];
                        }
                        NoOfAcc = parseInt(this.ContactDros.CRM06.NumberOfDepositAccounts || 0);
                        $("#NoOfAcc").html(NoOfAcc);
                        NetReimbursible = parseFloat(this.ContactDros.CRM06.NetReimbursible);
                        TaxAmount = parseFloat(this.ContactDros.CRM06.TaxAmount);
                        $("#Amount").html(this.Util.numberWithCommas(this.FormatNumber((isNaN(NetReimbursible) ? 0 : NetReimbursible) + (isNaN(TaxAmount) ? 0 : TaxAmount))));
                        $("#TaxAmount").html(this.Util.numberWithCommas(this.FormatNumber(isNaN(TaxAmount) ? 0 : TaxAmount)));
                        $("#NetAmount").html(this.Util.numberWithCommas(this.FormatNumber(isNaN(NetReimbursible) ? 0 : NetReimbursible)));
                        $("#PaymentStatus1_1").html("");
                        $("#PaymentStatus2_1").html("");
                        $("#PaymentStatus1_2").html("");
                        $("#PaymentStatus2_2").html("");
                        $("#PaymentStatus1_3").html("");
                        $("#PaymentStatus2_3").html("");
                        $("#PaymentStatus1_4").html("");
                        $("#PaymentStatus2_4").html("");
                        $("#PaymentStatus1_5").html("");
                        $("#PaymentStatus2_5").html("");
                        $("#divPaymentStatus").addClass("sr-only");
                        $("#Status1").html("");
                        $("#Status2").html("");
                        LastDate = null;
                        Rec03 = {}, Rec04 = {}, Rec05 = {}, Rec06 = {};
                        if (this.ContactDros.CRM04 != null || this.ContactDros.CRM04.length != 0) {
                            this.ContactDros.CRM04.forEach(function (a) {
                                if (LastDate == null) {
                                    //Rec04 = a;
                                    LastDate = new Date(a.ModifyDate.substring(0, 19));
                                }
                                else if (LastDate < new Date(a.ModifyDate.substring(0, 19))) {
                                    //Rec04 = a;
                                    LastDate = new Date(a.ModifyDate.substring(0, 19));
                                }
                            });
                            Rec04 = this.ContactDros.CRM04;
                            Rec05 = this.ContactDros.CRM05;
                            Rec06 = this.ContactDros.CRM06;
                            res04_type01 = Rec04.filter(function (a) { return a.RequestType == "จ่ายคืนผู้ฝาก"; });
                            res04_type02 = Rec04.filter(function (a) { return a.RequestType == "ยื่นคำขอรับเงิน"; });
                            res04_type03 = Rec04.filter(function (a) { return a.RequestType == "ยื่นคำขอรับเงิน (กรณีไม่พบข้อมูล)"; });
                            res04_type04 = Rec04.filter(function (a) { return a.RequestType == "ยื่นขอตรวจสอบ"; });
                            res04_type05 = Rec04.filter(function (a) { return a.RequestType == "ยื่นอุทธรณ์"; });
                            if (res04_type01.length > 0) {
                                StatusText1 = res04_type01[0].RequestType || "";
                                if (res04_type01[0].ChequeNo != null && res04_type01[0].ChequeNo != "") {
                                    StatusText1 += " เลขที่เช็ค " + res04_type01[0].ChequeNo;
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                if (res04_type01[0].ChequeIssueDate != null && res04_type01[0].ChequeIssueDate != "") {
                                    StatusText1 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type01[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                StatusText1 += " จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(Rec06.Reimbursable) ? 0 : Rec06.Reimbursable)) + " บาท";
                                $("#PaymentStatus1_1").html(StatusText1);
                                if (res04_type01[0].TransferedDate != null && res04_type01[0].TransferedDate != "") {
                                    v = this.translate.get("Date of payment");
                                    $("#PaymentStatus2_1").html(v.value + " " + this.Util.transformDate((new Date(res04_type01[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                            }
                            else {
                                $("#PaymentStatus1").addClass("sr-only");
                            }
                            if (res04_type02.length > 0) {
                                StatusText2 = res04_type02[0].RequestType || "";
                                if (res04_type02[0].ChequeNo != null && res04_type02[0].ChequeNo != "") {
                                    StatusText2 += " เลขที่เช็ค " + res04_type02.ChequeNo;
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                if (res04_type02[0].ChequeIssueDate != null && res04_type02[0].ChequeIssueDate != "") {
                                    StatusText2 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type02[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                StatusText2 += " จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(Rec06.Reimbursable) ? 0 : Rec06.Reimbursable)) + " บาท";
                                $("#PaymentStatus1_2").html(StatusText2);
                                if (res04_type02[0].TransferedDate != null && res04_type02[0].TransferedDate != "") {
                                    v = this.translate.get("Date of payment");
                                    $("#PaymentStatus2_2").html(v.value + " " + this.Util.transformDate((new Date(res04_type02[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                            }
                            else {
                                $("#PaymentStatus2").addClass("sr-only");
                            }
                            if (res04_type03.length > 0) {
                                StatusText3 = res04_type03[0].RequestType || "";
                                if (res04_type03[0].ChequeNo != null && res04_type03[0].ChequeNo != "") {
                                    StatusText3 += " เลขที่เช็ค " + res04_type03[0].ChequeNo;
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                if (res04_type03[0].ChequeIssueDate != null && res04_type03[0].ChequeIssueDate != "") {
                                    StatusText3 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type03[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                StatusText3 += " จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(Rec06.Reimbursable) ? 0 : Rec06.Reimbursable)) + " บาท";
                                $("#PaymentStatus1_3").html(StatusText3);
                                if (res04_type03[0].TransferedDate != null && res04_type03[0].TransferedDate != "") {
                                    v = this.translate.get("Date of payment");
                                    $("#PaymentStatus2_3").html(v.value + " " + this.Util.transformDate((new Date(res04_type03[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                            }
                            else {
                                $("#PaymentStatus3").addClass("sr-only");
                            }
                            if (res04_type04.length > 0) {
                                StatusText4 = res04_type04[0].RequestType || "";
                                if (res04_type04[0].ChequeNo != null && res04_type04[0].ChequeNo != "") {
                                    StatusText4 += " เลขที่เช็ค " + res04_type04.ChequeNo;
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                if (res04_type04[0].ChequeIssueDate != null && res04_type04[0].ChequeIssueDate != "") {
                                    StatusText4 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type04[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
                                    $("#divPaymentStatus").removeClass("sr-only");
                                    $("#PaymentStatus4").attr("style", "padding-bottom: 15px;");
                                }
                                res05Type04 = Rec05.filter(function (a) { return a.RequestTypeCode == 4; });
                                if (res05Type04.length > 0) {
                                    if (res05Type04[0].Result == "จ่ายเพิ่ม") {
                                        StatusText4 += " จ่ายคืนเงินคุ้มครองเพิ่มเติม จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type04[0].FinallyReimbursible) ? 0 : res05Type04[0].FinallyReimbursible)) + " บาท";
                                    }
                                    if (res05Type04[0].Result == "เท่าเดิม") {
                                        StatusText4 += " จ่ายคืนเงินคุ้มครองเท่าเดิม";
                                    }
                                    if (res05Type04[0].Result == "เรียกคืน") {
                                        StatusText4 += " เรียกคืนเงินฝาก จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type04[0].FinallyReimbursible) ? 0 : res05Type04[0].FinallyReimbursible)) + " บาท";
                                    }
                                    $("#PaymentStatus1_4").html(StatusText4);
                                    //$("#PaymentStatus2_4").addClass("sr-only");
                                    $("#PaymentStatus4 br").addClass("sr-only");
                                }
                                $("#PaymentStatus1_4").html(StatusText4);
                                if (res04_type04[0].TransferedDate != null && res04_type04[0].TransferedDate != "") {
                                    v = this.translate.get("Date of payment");
                                    $("#PaymentStatus2_4").html(v.value + " " + this.Util.transformDate((new Date(res04_type04[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
                                    $("#divPaymentStatus").removeClass("sr-only");
                                    $("#PaymentStatus4").attr("style", "padding-bottom: 15px;");
                                }
                            }
                            else {
                                res05Type04 = Rec05.filter(function (a) { return a.RequestTypeCode == 4; });
                                StatusText4 = "ยื่นขอตรวจสอบ";
                                if (res05Type04.length > 0) {
                                    if (res05Type04[0].Result == "จ่ายเพิ่ม") {
                                        StatusText4 += " จ่ายคืนเงินคุ้มครองเพิ่มเติม จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type04[0].FinallyReimbursible) ? 0 : res05Type04[0].FinallyReimbursible)) + " บาท";
                                    }
                                    if (res05Type04[0].Result == "เท่าเดิม") {
                                        StatusText4 += " จ่ายคืนเงินคุ้มครองเท่าเดิม";
                                    }
                                    if (res05Type04[0].Result == "เรียกคืน") {
                                        StatusText4 += " เรียกคืนเงินฝาก จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type04[0].FinallyReimbursible) ? 0 : res05Type04[0].FinallyReimbursible)) + " บาท";
                                    }
                                    $("#PaymentStatus1_4").html(StatusText4);
                                    $("#PaymentStatus2_4").addClass("sr-only");
                                    $("#PaymentStatus4 br").addClass("sr-only");
                                }
                                else {
                                    $("#PaymentStatus4").addClass("sr-only");
                                }
                            }
                            if (res04_type05.length > 0) {
                                StatusText5 = res04_type05[0].RequestType || "";
                                if (res04_type05[0].ChequeNo != null && res04_type05[0].ChequeNo != "") {
                                    StatusText5 += " เลขที่เช็ค " + res04_type05.ChequeNo;
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                if (res04_type05[0].ChequeIssueDate != null && res04_type05[0].ChequeIssueDate != "") {
                                    StatusText5 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type05[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                                res05Type05 = Rec05.filter(function (a) { return a.RequestTypeCode == 5; });
                                if (res05Type05.length > 0) {
                                    if (res05Type05[0].Result == "จ่ายเพิ่ม") {
                                        StatusText5 += " จ่ายคืนเงินคุ้มครองเพิ่มเติม จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type05[0].FinallyReimbursible) ? 0 : res05Type05[0].FinallyReimbursible)) + " บาท";
                                    }
                                    if (res05Type05[0].Result == "เท่าเดิม") {
                                        StatusText5 += " จ่ายคืนเงินคุ้มครองเท่าเดิม";
                                    }
                                    if (res05Type05[0].Result == "เรียกคืน") {
                                        StatusText5 += " เรียกคืนเงินฝาก จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type05[0].FinallyReimbursible) ? 0 : res05Type05[0].FinallyReimbursible)) + " บาท";
                                    }
                                    $("#PaymentStatus1_5").html(StatusText5);
                                    //$("#PaymentStatus2_5").addClass("sr-only");
                                    $("#PaymentStatus5 br").addClass("sr-only");
                                }
                                $("#PaymentStatus1_5").html(StatusText5);
                                if (res04_type05[0].TransferedDate != null && res04_type05[0].TransferedDate != "") {
                                    v = this.translate.get("Date of payment");
                                    $("#PaymentStatus2_5").html(v.value + " " + this.Util.transformDate((new Date(res04_type05[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
                                    $("#divPaymentStatus").removeClass("sr-only");
                                }
                            }
                            else {
                                res05Type05 = Rec05.filter(function (a) { return a.RequestTypeCode == 5; });
                                StatusText5 = "ยื่นอุทธรณ์";
                                if (res05Type05.length > 0) {
                                    if (res05Type05[0].Result == "จ่ายเพิ่ม") {
                                        StatusText5 += " จ่ายคืนเงินคุ้มครองเพิ่มเติม จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type05[0].FinallyReimbursible) ? 0 : res05Type05[0].FinallyReimbursible)) + " บาท";
                                    }
                                    if (res05Type05[0].Result == "เท่าเดิม") {
                                        StatusText5 += " จ่ายคืนเงินคุ้มครองเท่าเดิม";
                                    }
                                    if (res05Type05[0].Result == "เรียกคืน") {
                                        StatusText5 += " เรียกคืนเงินฝาก จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type05[0].FinallyReimbursible) ? 0 : res05Type05[0].FinallyReimbursible)) + " บาท";
                                    }
                                    $("#PaymentStatus1_5").html(StatusText5);
                                    $("#PaymentStatus2_5").addClass("sr-only");
                                    $("#PaymentStatus5 br").addClass("sr-only");
                                }
                                else {
                                    $("#PaymentStatus5").addClass("sr-only");
                                }
                            }
                        }
                        if (this.ContactDros.CRM03 != null || this.ContactDros.CRM03.length != 0) {
                            LastDate = null;
                            this.ContactDros.CRM03.forEach(function (a) {
                                if (LastDate == null) {
                                    Rec03 = a;
                                    LastDate = new Date(a.ModifyDate.substring(0, 19));
                                }
                                else if (LastDate < new Date(a.ModifyDate.substring(0, 19))) {
                                    Rec03 = a;
                                    LastDate = new Date(a.ModifyDate.substring(0, 19));
                                }
                            });
                            $("#Status1").html(Rec03.StatusDefinitionCustPortal);
                            $("#Status2").html("วันที่ " + this.Util.transformDate(LastDate.toISOString().substring(0, 10), "short"));
                        }
                        $("#divBankList").addClass("sr-only");
                        $("#divSummary").removeClass("sr-only");
                        return [4 /*yield*/, this.ReqAdditionalDoc()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.InvestigateAndAppealCondition(BankCode)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.InvestigateAndAppealCondition = function (BankCode) {
        return __awaiter(this, void 0, void 0, function () {
            var result, para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.Contact.dpa_ndidflag == true)) return [3 /*break*/, 6];
                        if (!!this.Util.IsNullOrUndefined(this.ContactDros.CRM06)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.Api.postCustomApi("Dros", "webAuth", { uid: this.ContactDros.CRM06.UID })];
                    case 1:
                        result = _a.sent();
                        if (!(!this.Util.IsNullOrUndefined(result) && result.length > 0)) return [3 /*break*/, 5];
                        if (!(!this.Util.IsNullOrUndefined(result[0].resultCode) && result[0].resultCode == "00")) return [3 /*break*/, 2];
                        if (!this.Util.IsNullOrUndefined(result[0].links) && result[0].links.length > 0) {
                            console.log(result);
                            this.drosWeb = result[0].links[0].webURL;
                            if (result[0].actiontype == 1) {
                                $("#lblInvestigate").html("แจ้งช่องทางการรับเงิน");
                            }
                            else if (result[0].actiontype == 2) {
                                $("#lblInvestigate").html("ยื่นคำขอรับเงิน");
                            }
                            else if (result[0].actiontype == 4) {
                                $("#lblInvestigate").html("ยื่นขอตรวจสอบ");
                            }
                            else if (result[0].actiontype == 5) {
                                $("#lblInvestigate").html("ยื่นอุทธรณ์");
                            }
                            else {
                                $("#lblInvestigate").html("ยื่นอุทธรณ์");
                            }
                            $("#btnInvestigate").removeClass("sr-only");
                        }
                        else {
                            $("#btnInvestigate").addClass("sr-only");
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        para = "ResultCode=" + result[0].resultCode;
                        return [4 /*yield*/, this.Api.get("crmservice", "getErrorCode", para)];
                    case 3:
                        tmp = _a.sent();
                        if (!this.Util.IsNullOrUndefined(tmp.ResultMessage)) {
                            this.Util.WarningDialog(tmp.ResultMessage);
                        }
                        else {
                            this.Util.WarningDialog("ระบบขัดข้อง ไม่สามารถใช้งานได้ชั่วคราว");
                            $("#btnInvestigate").addClass("sr-only");
                            $("#btnAdditionalDoc").addClass("sr-only");
                            $("#btnsentmaildoc").addClass("sr-only");
                        }
                        $("#btnInvestigate").addClass("sr-only");
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        $("#btnInvestigate").addClass("sr-only");
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.CreateTable1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.router.navigate(["singlegatewaywait2"]);
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.ReqAdditionalDoc = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selected, arr1, arr2, sortedDesc, sortedDescAll, crm03file;
            return __generator(this, function (_a) {
                if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM03)) {
                    selected = this.ContactDros.CRM03.filter(function (a) { return a.FilePath != null && a.FilePath != "" && a.FilePath.split('_')[1] == "05.pdf"; });
                    arr1 = selected.map(function (obj) { return __assign({}, obj, { date: new Date(obj.ModifyDate) }); });
                    arr2 = this.ContactDros.CRM03.map(function (obj) { return __assign({}, obj, { date: new Date(obj.ModifyDate) }); });
                    sortedDesc = arr1.sort(function (objA, objB) { return objB.date.getTime() - objA.date.getTime(); });
                    sortedDescAll = arr2.sort(function (objA, objB) { return objB.date.getTime() - objA.date.getTime(); });
                    if (sortedDesc.length > 0) {
                        if (sortedDescAll.length > 0) {
                            if (sortedDesc[0].ModifyDate == sortedDescAll[0].ModifyDate) {
                                this.PathPdf = sortedDesc[0].FilePath;
                                $("#btnAdditionalDoc").removeClass("sr-only");
                            }
                            else {
                                $("#btnAdditionalDoc").addClass("sr-only");
                            }
                        }
                        else {
                            $("#btnAdditionalDoc").addClass("sr-only");
                        }
                    }
                    else {
                        $("#btnAdditionalDoc").addClass("sr-only");
                    }
                }
                else {
                    $("#btnAdditionalDoc").addClass("sr-only");
                }
                if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM03)) {
                    crm03file = this.ContactDros.CRM03.filter(function (a) { return a.FilePath != null; });
                    if (crm03file != null && crm03file.length > 0) {
                        $("#btnsentmaildoc").removeClass("sr-only");
                    }
                    else {
                        $("#btnsentmaildoc").addClass("sr-only");
                    }
                }
                else {
                    $("#btnsentmaildoc").addClass("sr-only");
                }
                return [2 /*return*/];
            });
        });
    };
    RefundDepositsComponent.prototype.openPDF = function (pdfPath) {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp, fileName, vfilename, objbuilder, linkSource, win2_1, html_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(pdfPath != "")) return [3 /*break*/, 2];
                        para = "FilePath=" + pdfPath;
                        return [4 /*yield*/, this.Api.get("crmservice", "getFileDROS2", para)];
                    case 1:
                        tmp = _a.sent();
                        fileName = pdfPath.split('/');
                        vfilename = fileName[fileName.length - 1];
                        objbuilder = '';
                        linkSource = tmp.File;
                        console.log(tmp.size);
                        win2_1 = window.open("", "_blank");
                        html_1 = '';
                        html_1 += '<html><head><title>' + vfilename + '</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>';
                        html_1 += '<body style="margin:0!important">';
                        html_1 += '<embed width="100%" height="100%" src="data:application/pdf;base64,' + encodeURI(linkSource) + '" type="application/pdf" />';
                        html_1 += '</body>';
                        html_1 += '</html>';
                        setTimeout(function () {
                            win2_1.document.write(html_1);
                        }, 0);
                        return [3 /*break*/, 3];
                    case 2:
                        this.Util.WarningDialog("ไม่มีข้อมูลการขอเอกสารเพิ่มจากสถาบันคุ้มครองเงินฝาก");
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.Back = function () {
        $("#divBankList").removeClass("sr-only");
        $("#divSummary").addClass("sr-only");
    };
    RefundDepositsComponent.prototype.PDF = function () {
        // For test purpose
        var FileName = "";
        var IDNo = this.Ticket.dpa_idcard == null ? this.Ticket.dpa_registrationid == null ? this.Ticket.dpa_passport : this.Ticket.dpa_registrationid : this.Ticket.dpa_idcard;
        switch (IDNo) {
            case "9442643182995":
                FileName = "202103190001_STATEMENT.pdf";
                break;
            case "6932044986885":
                FileName = "202103190002_STATEMENT.pdf";
                break;
            case "105513001952":
                FileName = "202103190003_STATEMENT.pdf";
                break;
            case "105513001953":
                FileName = "202103190004_STATEMENT.pdf";
                break;
            case "1532781893998":
                FileName = "202103190005_STATEMENT.pdf";
                break;
            case "2138007773113":
                FileName = "202103190006_STATEMENT.pdf";
                break;
            case "5506495856063":
                FileName = "2021032200001_STATEMENT.pdf";
                break;
            case "9658097573669":
                FileName = "2021032200002_STATEMENT.pdf";
                break;
            case "105514006644":
                FileName = "2021032200003_STATEMENT.pdf";
                break;
            case "2219787820779":
                FileName = "2021032300001_STATMENT.pdf";
                break;
            case "8883211078728":
                FileName = "2021032300002_STATMENT.pdf";
                break;
            case "7485595890162":
                FileName = "2021032300003_STATMENT.pdf";
                break;
            case "MM1234561":
                FileName = "2021032300004_STATMENT.pdf";
                break;
            case "MM1234562":
                FileName = "2021032300005_STATMENT.pdf";
                break;
            case "MM1234563":
                FileName = "2021032300006_STATMENT.pdf";
                break;
            case "105517012921":
                FileName = "2021032300007_STATMENT.pdf";
                break;
            case "105520001081":
                FileName = "2021032300008_STATMENT.pdf";
                break;
            case "105520001082":
                FileName = "2021032300009_STATMENT.pdf";
                break;
            case "7595816874309":
                FileName = "2021032400001_STATEMENT.pdf";
                break;
            case "9442643182995":
                FileName = "2021032400002_STATEMENT.pdf";
                break;
            case "6932044986885":
                FileName = "2021032400003_STATEMENT.pdf";
                break;
            case "9676233842512":
                FileName = "202110149676233842512-STM.pdf";
                break;
            case "3509900002059":
                FileName = "202110143509900002059_STM.pdf";
                break;
        }
        window.open("assets/dist/pdf/" + FileName, "_blank");
        //window.open("../assets/dist/pdf/202111490001_STATEMENT.pdf", "_blank");
    };
    RefundDepositsComponent.prototype.FormatNumber = function (Num) {
        try {
            return Num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
        catch (e) {
            return Num;
        }
    };
    RefundDepositsComponent.prototype.DateDiff = function (d1, d2) {
        var dt1 = new Date(d1);
        var dt2 = new Date(d2);
        return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24)) + 1;
    };
    RefundDepositsComponent.prototype.ClearText = function () {
        $("#FirstNameDOPA").val("");
        $("#LastNameDOPA").val("");
        $("#IDNoDOPA").val("");
        $("#LaserNoDOPA").val("");
        $("#BirthDateDOPA").val("");
        $("#PhoneNoDOPA").val("");
    };
    RefundDepositsComponent.prototype.SetState = function (State) {
        var CookieData = localStorage.getItem("dpa_portal");
        if (CookieData == null || CookieData == "") {
            return;
        }
        CookieData = JSON.parse(CookieData);
        CookieData.refundState = State;
        localStorage.setItem("dpa_portal", JSON.stringify(CookieData));
    };
    RefundDepositsComponent.prototype.GetState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var CookieData;
            return __generator(this, function (_a) {
                CookieData = localStorage.getItem("dpa_portal");
                if (CookieData == null || CookieData == "") {
                    return [2 /*return*/, ""];
                }
                CookieData = JSON.parse(CookieData);
                return [2 /*return*/, CookieData.refundState == null || CookieData.refundState == undefined ? "" : CookieData.refundState];
            });
        });
    };
    RefundDepositsComponent.prototype.GotoState = function (State) {
        $("#divStart").addClass("sr-only");
        $("#divStart2").addClass("sr-only");
        $("#divOTP").addClass("sr-only");
        if (State.toLowerCase() == "skipotp") {
            this.SubmitOTP();
        }
        else if (State.toLowerCase() == "consent") {
            this.ShowConsentForm();
        }
        else if (State.toLowerCase() == "banklist") {
            this.ShowBankList();
        }
    };
    RefundDepositsComponent.prototype.numberAndAlphabetOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (!(charCode > 47 && charCode < 58) && // numeric (0-9)
            !(charCode > 64 && charCode < 91) && // upper alpha (A-Z)
            !(charCode > 96 && charCode < 123)) {
            return false;
        }
        return true;
    };
    RefundDepositsComponent.prototype.RequestOTP = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var ParamObj, Res, Msg, SmsRes, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        ParamObj = {
                            MobileNo: this.Contact.telephone1
                        };
                        return [4 /*yield*/, this.Api.postCustomApi("Crm", "RequestOTP", ParamObj)];
                    case 1:
                        Res = _a.sent();
                        if (this.Util.isSuccessResponse(Res)) {
                            //Res = this.Util.AesDecryptDictValue(Res.json());
                            this.OTPRefCode = Res.RefCode;
                            $("#OTPRefCode").html(Res.RefCode);
                            Msg = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : ";
                            Msg += Res.otpNo + " ";
                            Msg += "(RefCode : " + Res.RefCode;
                            Msg += ") (รหัสมีอายุ " + Res.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น";
                            ParamObj = {
                                dpa_phoneno: this.Contact.telephone1,
                                dpa_description: Msg
                            };
                            SmsRes = this.Api.post("crmservice", "sendSms", ParamObj);
                            $("#btnSubmitOTP").removeAttr("disabled");
                            if (Res.expInMinute == undefined || Res.expInMinute == null) {
                                this.TotalTime = 300;
                            }
                            else {
                                this.TotalTime = Res.expInMinute * 60;
                            }
                            this.ElapseTime = 0;
                            if (this.SubScr != undefined) {
                                this.SubScr.unsubscribe();
                            }
                            this.SubScr = timer(0, 1000).subscribe(function () { return _this.CountDownOTP(); });
                            this.WaitTime = 60;
                            $("#btnRequestOTP").attr("disabled", "disabled");
                            if (this.SubScr2 != undefined) {
                                this.SubScr2.unsubscribe();
                            }
                            this.SubScr2 = timer(0, 1000).subscribe(function () { return _this.CountDownWaitTime(); });
                        }
                        else {
                            $("#btnSubmitOTP").attr("disabled", "disabled");
                            this.Util.ShowWaiting(false);
                            this.Util.WarningDialog("เกิดข้อผิดพลาดในการขอรหัส OTP กรุณาติดต่อผู้ดูแลระบบ");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        $("#btnSubmitOTP").attr("disabled", "disabled");
                        this.Util.ShowWaiting(false);
                        this.Util.WarningDialog("เกิดข้อผิดพลาดในการขอรหัส OTP กรุณาติดต่อผู้ดูแลระบบ");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RefundDepositsComponent.prototype.CountDownOTP = function () {
        if (this.ElapseTime == 0 && this.TotalTime == 0) {
            this.SubScr.unsubscribe();
            return;
        }
        if (this.ElapseTime == this.TotalTime) {
            this.SubScr.unsubscribe();
            $("#btnSubmitOTP").attr("disabled", "disabled");
            $("#btnSubmitOTP").html("ยืนยัน");
            this.ElapseTime = 0;
            return;
        }
        this.ElapseTime++;
        var RemainingSecs = this.TotalTime - this.ElapseTime;
        var RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
        RemainingSecs = RemainingSecs % 60;
        $("#btnSubmitOTP").html("ยืนยัน " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs);
    };
    RefundDepositsComponent.prototype.CountDownWaitTime = function () {
        if (this.WaitTime == 0) {
            $("#btnRequestOTP").html("ขอรหัสอีกครั้ง");
            $("#btnRequestOTP").removeAttr("disabled");
            this.SubScr2.unsubscribe();
            return;
        }
        this.WaitTime--;
        $("#btnRequestOTP").html("ขอรหัสอีกครั้ง " + this.WaitTime);
    };
    RefundDepositsComponent.prototype.GetStatusGuidByCode = function (code) {
        var found = this.masterStatus.filter(function (s) {
            return s.dpa_code == code;
        });
        if (found != null && found.length > 0) {
            return found[0].dpa_approvalstatusid;
        }
        else {
            return null;
        }
    };
    RefundDepositsComponent.prototype.sentmailDoc = function () {
        this.Util.ShowWaiting(true);
        if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06.IDNo)) {
            var ParamObj = {
                idno: this.ContactDros.CRM06.IDNo,
                email: this.Contact.emailaddress1
            };
            var res = this.Api.post("crmservice", "SendDocument", ParamObj);
            console.log(res);
            if (this.Util.isSuccessResponse(res)) {
                this.Util.SuccessDialog("บันทึกข้อมูลสำเร็จ");
            }
            else {
                this.Util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
            }
        }
        this.Util.ShowWaiting(false);
    };
    RefundDepositsComponent.prototype.GetErrorMsgCheckCard = function (obj) {
        var msg = "";
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                if (Array.isArray(obj[prop]) && obj[prop] != null && obj[prop].length > 0) {
                    obj[prop].forEach(function (m) {
                        msg = msg == "" ? m : msg + ", " + m;
                    });
                }
                else if (typeof obj[prop] == "string") {
                    msg = msg == "" ? obj[prop] : msg + ", " + obj[prop];
                }
            }
        }
        return msg;
    };
    RefundDepositsComponent.prototype.ngOnDestroy = function () {
        //prevent memory leak when component destroyed
        if (this.SubScr != undefined) {
            this.SubScr.unsubscribe();
        }
        if (this.SubScr2 != undefined) {
            this.SubScr2.unsubscribe();
        }
    };
    return RefundDepositsComponent;
}());
export { RefundDepositsComponent };



// WEBPACK FOOTER //
// ./src/app/refund-deposits/refund-deposits.component.ts.pre-build-optimizer.js